(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-brands"] && !Shopify.designMode) return;
  try {
    
function initVerdosaBrands(){
  document.querySelectorAll('.vd-brands').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const track=section.querySelector('.vd-brands__track');
    const scrollbar=section.querySelector('.vd-brands__mobile-scroll');
    const update=()=>{
      const maximum=track.scrollWidth-track.clientWidth;
      scrollbar.disabled=maximum<2;
      scrollbar.value=maximum>0?Math.round(track.scrollLeft/maximum*1000):0;
      scrollbar.style.setProperty('--vd-thumb-width',Math.max(32,track.clientWidth*track.clientWidth/track.scrollWidth)+'px');
    };
    scrollbar.addEventListener('input',()=>{
      track.style.scrollSnapType='none';
      track.scrollLeft=Number(scrollbar.value)/1000*(track.scrollWidth-track.clientWidth);
    });
    scrollbar.addEventListener('change',()=>{track.style.scrollSnapType='';});
    track.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initVerdosaBrands();
document.addEventListener('shopify:section:load',initVerdosaBrands);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-catalogue-nav"] && !Shopify.designMode) return;
  try {
    
(()=>{
const init=()=>document.querySelectorAll('[data-catalog-search-form]').forEach(form=>{
if(form.dataset.ready)return;form.dataset.ready='true';
const input=form.querySelector('input'),status=form.querySelector('[data-catalog-search-status]');
let lastGrid,lastKey='',serial=0,timer,allCards=[],busy=false;
const normalize=s=>s.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
function filter(){
const terms=normalize(input.value.trim()).split(/\s+/).filter(Boolean);let found=0;
allCards.forEach(card=>{const match=terms.every(term=>normalize(card.dataset.catalogSearch||card.textContent).includes(term));card.hidden=!match;if(match)found++});
status.textContent=terms.length?(busy?'Searching products…':found?found+' matching product'+(found===1?'':'s')+'.':'No matching products with the current filters. Try another name or adjust your filters.'):'';
}
async function sync(){
const grid=document.querySelector('results-list .product-grid'),component=document.querySelector('results-list');if(!grid||!component)return;
const u=new URL(location.href);u.searchParams.delete('page');u.searchParams.delete('preview_theme_id');const key=u.pathname+u.search;
const changed=grid!==lastGrid||key!==lastKey;
if(changed){lastGrid=grid;lastKey=key;allCards=[...grid.querySelectorAll('.verdosa-catalogue-card')];serial++;busy=false}
if(!input.value.trim()){serial++;busy=false;allCards.forEach(card=>{if(card.dataset.catalogAppended)card.remove();else card.hidden=false});allCards=[...grid.querySelectorAll('.verdosa-catalogue-card')];grid.removeAttribute('aria-busy');status.textContent='';grid.removeAttribute('data-catalog-loaded');return}
filter();if(busy||grid.dataset.catalogLoaded)return;
const token=++serial;busy=true;grid.setAttribute('aria-busy','true');filter();
try{
const ids=new Set(allCards.map(el=>el.dataset.productId));let next=component.querySelector('[data-catalog-next]')?.dataset.catalogNext;const seen=new Set();
while(next&&!seen.has(next)){seen.add(next);const url=new URL(next,location.origin);url.searchParams.set('section_id',component.getAttribute('section-id'));const response=await fetch(url);if(!response.ok)throw Error('load');
const doc=new DOMParser().parseFromString(await response.text(),'text/html');if(!doc.querySelector('results-list'))throw Error('template');
if(token!==serial)return;
doc.querySelectorAll('.verdosa-catalogue-card').forEach(card=>{if(!ids.has(card.dataset.productId)){ids.add(card.dataset.productId);card.dataset.catalogAppended='true';grid.append(card);allCards.push(card)}});
next=doc.querySelector('[data-catalog-next]')?.dataset.catalogNext;
}
if(token!==serial)return;grid.dataset.catalogLoaded='true';busy=false;grid.removeAttribute('aria-busy');filter();
}catch{if(token===serial){busy=false;grid.removeAttribute('aria-busy');filter();status.textContent='Could not search every page. Showing loaded products; please try again.'}}
}
const schedule=()=>{clearTimeout(timer);timer=setTimeout(sync,150)};
input.addEventListener('input',schedule);form.addEventListener('submit',event=>{event.preventDefault();clearTimeout(timer);sync()});
new MutationObserver(()=>{const grid=document.querySelector('results-list .product-grid');const u=new URL(location.href);u.searchParams.delete('page');u.searchParams.delete('preview_theme_id');if(grid!==lastGrid||u.pathname+u.search!==lastKey)schedule();else if(grid){const cards=[...grid.querySelectorAll('.verdosa-catalogue-card')];if(cards.length!==allCards.length||cards.some((card,i)=>card!==allCards[i])){lastGrid=null;schedule()}}}).observe(document.querySelector('main'),{childList:true,subtree:true});
window.addEventListener('popstate',schedule);sync();
});init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-comparisons-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
const init=()=>document.querySelectorAll('[data-vc-search]').forEach(form=>{
if(form.dataset.ready)return;form.dataset.ready='true';
const hub=form.closest('.vc-hub'),input=form.querySelector('input'),grid=hub.querySelector('.vc-featured'),heading=hub.querySelector('.vc-featured-heading'),status=form.querySelector('[role="status"]'),pages=hub.querySelector('.vc-search-pages'),pagination=hub.querySelector('.vc-pagination');
const extra=[hub.querySelector('.vc-match'),hub.querySelector('.vc-latest-head'),hub.querySelector('.vc-latest-grid')].filter(Boolean);
const original=[...grid.children].map(el=>el.cloneNode(true)),label=heading.textContent;
let records=original,loaded=!pagination,pending,timer,page=0,failed=false;
const normalize=value=>value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
const draw=()=>{
const query=normalize(input.value.trim());extra.forEach(el=>el.hidden=!!query);if(pagination)pagination.hidden=!!query;
heading.textContent=query?'Search results':label;pages.hidden=true;
if(!query){grid.replaceChildren(...original.map(el=>el.cloneNode(true)));status.textContent='';grid.removeAttribute('aria-busy');return}
const terms=query.split(/\s+/).filter(Boolean),matches=records.filter(el=>terms.every(term=>normalize(el.dataset.vcTags||el.querySelector('h3').textContent).includes(term)));
const totalPages=Math.ceil(matches.length/10);page=Math.max(0,Math.min(page,totalPages-1));
grid.replaceChildren(...matches.slice(page*10,page*10+10).map(el=>el.cloneNode(true)));
grid.setAttribute('aria-busy',String(!loaded&&!failed));
status.textContent=failed?'Could not load every comparison. Showing matches from the current page; clear the search and try again.':!loaded?'Searching all comparisons…':matches.length?matches.length+' comparison'+(matches.length===1?'':'s')+' found.':'No comparisons found. Try a brand or model name.';
pages.hidden=totalPages<2;pages.querySelector('span').textContent=(page+1)+' / '+totalPages;
pages.querySelector('[data-page="-1"]').disabled=page===0;pages.querySelector('[data-page="1"]').disabled=page>=totalPages-1;
};
const load=async()=>{
if(loaded||pending)return pending;
failed=false;pending=(async()=>{
let url=new URL(form.dataset.blogUrl,location.origin);const seen=new Set(),unique=new Map();
while(url&&!seen.has(url.href)){seen.add(url.href);const response=await fetch(url.href);if(!response.ok)throw Error('load');
const doc=new DOMParser().parseFromString(await response.text(),'text/html');if(!doc.querySelector('.vc-featured'))throw Error('template');
doc.querySelectorAll('.vc-featured .vc-card').forEach(el=>unique.set(el.querySelector('h3 a').getAttribute('href'),el));
const next=doc.querySelector('.vc-pagination .next a');url=next?new URL(next.getAttribute('href'),location.origin):null}
records=[...unique.values()];loaded=true;
})().catch(()=>{failed=true}).finally(()=>{pending=null;draw()});return pending;
};
const run=()=>{page=0;draw();if(input.value.trim())load()};
input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(run,120)});
form.addEventListener('submit',event=>{event.preventDefault();clearTimeout(timer);run()});
pages.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>{page+=Number(button.dataset.page);draw()}));
});init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-head-to-head"] && !Shopify.designMode) return;
  try {
    
function initVerdosaH2H(){
document.querySelectorAll('.vh').forEach(async root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const t=Object.fromEntries([...root.querySelectorAll('[data-key]')].map(n=>[n.dataset.key,n.textContent]));
const a=root.querySelector('[data-a]'),b=root.querySelector('[data-b]'),out=root.querySelector('[data-results]'),status=root.querySelector('[data-status]'),profiles=new Map();
const node=(tag,text,cls)=>{const n=document.createElement(tag);if(text!=null)n.textContent=text;if(cls)n.className=cls;return n};
const url=v=>{if(!v)return null;try{const u=new URL(v,location.origin);return /^https?:$/.test(u.protocol)?u.href:null}catch{return null}};
function collect(feed){
feed.querySelectorAll('[data-review]').forEach(n=>{
const p=JSON.parse(n.querySelector('script').textContent),doc=new DOMParser().parseFromString(n.querySelector('textarea').value,'text/html');
p.specs={};
const specLabel=label=>/^(official |published )?weight$/i.test(label)?'Weight':label;
const h=[...doc.querySelectorAll('h2,h3')].find(x=>/specification/i.test(x.textContent));
if(h){let next=h.nextElementSibling;while(next&&!/^H[23]$/.test(next.tagName)){const table=next.matches('table')?next:next.querySelector('table');if(table){table.querySelectorAll('tbody tr').forEach(row=>{const cells=row.querySelectorAll('th,td');if(cells.length>1&&!/price/i.test(cells[0].textContent)){const original=cells[0].textContent.trim(),key=specLabel(original),value=(key!==original?original+': ':'')+cells[1].textContent.trim();p.specs[key]=p.specs[key]?p.specs[key]+'; '+value:value}});break}next=next.nextElementSibling}}
const pl=[...doc.querySelectorAll('a[href]')].find(n=>{try{return new URL(n.getAttribute('href'),location.origin).pathname.startsWith('/products/')}catch{return false}});
const affiliate=[...doc.querySelectorAll('a[href]')].find(n=>{const href=url(n.getAttribute('href'));return href&&(n.rel.split(/\s+/).includes('sponsored')||/(^|\.)(amazon\.[a-z.]+|amzn\.to|link\.amazon)$/.test(new URL(href).hostname))});
p.product=url(p.retailer?.url)||url(affiliate?.getAttribute('href'))||(pl?url(pl.getAttribute('href')):null);if(!p.product&&p.handle.endsWith('adidas-adizero-adios-pro-5-review'))p.product=url('https://link.amazon/B0eOiQjde');if(!p.product&&p.handle.endsWith('adidas-adizero-evo-sl-review'))p.product=url('/products/adidas-adizero-evo-sl-men-s-running-shoes');if(!p.product&&p.handle.endsWith('asics-superblast-3-review'))p.product=url('/products/asics-superblast-3-unisex-running-shoes');

profiles.set(p.handle,p);
});
}
let feed=root.querySelector('[data-feed]'),next=feed.dataset.next;
collect(feed);
const seen=new Set();let failed=false;
try{while(next&&!seen.has(next)){seen.add(next);const u=new URL(next,location.origin);u.searchParams.set('section_id',root.dataset.section);const res=await fetch(u);if(!res.ok)throw new Error();const doc=new DOMParser().parseFromString(await res.text(),'text/html');feed=doc.querySelector('[data-feed]');if(!feed)throw new Error();collect(feed);next=feed.dataset.next}}catch{failed=true}
const list=[...profiles.values()].sort((x,y)=>x.title.localeCompare(y.title));
if(list.length<2){status.textContent=t.empty;return}
for(const s of [a,b]){s.replaceChildren(...list.map(p=>{const o=node('option',p.title);o.value=p.handle;return o}));s.disabled=false}
const params=new URLSearchParams(location.search);a.value=profiles.has(params.get('shoe1'))?params.get('shoe1'):list[0].handle;b.value=profiles.has(params.get('shoe2'))&&params.get('shoe2')!==a.value?params.get('shoe2'):list.find(p=>p.handle!==a.value).handle;
function link(label,href,buying=false){const n=node('a',label,'vh-link');n.href=url(href);if(buying){n.rel='sponsored nofollow noopener';if(new URL(n.href).origin!==location.origin)n.target='_blank'}return n}
function content(p,key){const box=node('div'),value=p[key];if(Array.isArray(value)&&value.length){const ul=node('ul');value.forEach(v=>ul.append(node('li',v)));box.append(ul)}else box.append(node('p',typeof value==='string'&&value?value:t.missing));return box}
function animateAccordion(details,summary){
let animation=null,expanded=false;
summary.addEventListener('click',event=>{
event.preventDefault();
const start=details.getBoundingClientRect().height;
expanded=!expanded;
if(animation){animation.cancel();animation=null}
details.open=true;
details.classList.toggle('vh-is-open',expanded);
summary.setAttribute('aria-expanded',String(expanded));
const end=expanded?details.scrollHeight:summary.getBoundingClientRect().height+2;
if(matchMedia('(prefers-reduced-motion: reduce)').matches){details.open=expanded;return}
animation=details.animate({height:[start+'px',end+'px']},{duration:360,easing:'cubic-bezier(.22,1,.36,1)'});
animation.onfinish=()=>{details.open=expanded;animation=null};
});
}

function makePicker(select,side){
const wrap=node('div',null,'vh-picker'),field=node('div',null,'vh-picker__field');
field.innerHTML='<svg class="vh-picker__icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="7.5"/><path d="m16 16 5 5"/></svg>';
const input=node('input');input.id='vh-search-'+side+'-'+root.dataset.section;input.type='text';input.autocomplete='off';input.placeholder='Search brand or model';
input.setAttribute('role','combobox');input.setAttribute('aria-autocomplete','list');input.setAttribute('aria-expanded','false');
const menu=node('div',null,'vh-picker__list');menu.id=input.id+'-options';menu.setAttribute('role','listbox');menu.setAttribute('aria-label',side==='a'?'Available shoes for Shoe A':'Available shoes for Shoe B');menu.hidden=true;input.setAttribute('aria-controls',menu.id);
const hint=node('p','Type a brand or model to narrow the available shoes.','vh-picker__hint');hint.id=input.id+'-hint';input.setAttribute('aria-describedby',hint.id);
field.append(input);wrap.append(field,menu,hint);select.parentElement.append(wrap);
let active=-1,options=[],opened=false;
const normalize=value=>value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
function close(){opened=false;menu.hidden=true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');input.value=profiles.get(select.value)?.title||'';hint.textContent='Type a brand or model to narrow the available shoes.'}
function highlight(index){active=index;options.forEach((el,i)=>el.classList.toggle('is-active',i===active));if(active>=0){input.setAttribute('aria-activedescendant',options[active].id);options[active].scrollIntoView({block:'nearest'})}else input.removeAttribute('aria-activedescendant')}
function choose(handle){if(handle===(select===a?b:a).value)return;select.value=handle;render();close();input.focus()}
function draw(query){
opened=true;menu.hidden=false;input.setAttribute('aria-expanded','true');menu.replaceChildren();active=-1;input.removeAttribute('aria-activedescendant');options=[];
const terms=normalize(query).trim().split(/\s+/).filter(Boolean),matches=list.filter(p=>terms.every(term=>normalize(p.title).includes(term)));
hint.textContent=matches.length+' available model'+(matches.length===1?'':'s')+'.';
if(!matches.length){menu.append(node('div','No matching reviewed shoes. Try another brand or model.','vh-picker__empty'));return}
matches.forEach((p,i)=>{const option=node('div',null,'vh-picker__option');option.id=menu.id+'-'+i;option.setAttribute('role','option');option.setAttribute('aria-selected',String(p.handle===select.value));const unavailable=p.handle===(select===a?b:a).value;option.setAttribute('aria-disabled',String(unavailable));
if(url(p.image)){const img=node('img');img.src=url(p.image);img.alt='';img.loading='lazy';option.append(img)}
option.append(node('span',p.title+(unavailable?' — selected in other slot':'')));option.addEventListener('pointerdown',event=>event.preventDefault());option.addEventListener('click',()=>choose(p.handle));menu.append(option);if(!unavailable)options.push(option);
option.dataset.handle=p.handle;
});
}
input.addEventListener('focus',()=>{input.select();draw('')});
input.addEventListener('click',()=>{if(!opened){input.select();draw('')}});
input.addEventListener('input',()=>draw(input.value));
input.addEventListener('keydown',event=>{
if(event.key==='Escape'){event.preventDefault();close();return}
if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();if(!opened)draw('');if(options.length)highlight(event.key==='ArrowDown'?(active+1)%options.length:(active<=0?options.length-1:active-1));return}
if(event.key==='Enter'){event.preventDefault();if(opened&&active>=0)choose(options[active].dataset.handle);else if(opened&&options.length===1)choose(options[0].dataset.handle);else if(!opened)draw('')}
if(event.key==='Tab')close();
});
input.addEventListener('blur',()=>close());
return{sync:()=>{if(!opened)input.value=profiles.get(select.value)?.title||''},close};
}

function render(){
if(typeof pickers!=='undefined')pickers.forEach(p=>p.sync());
for(const o of a.options)o.disabled=o.value===b.value;for(const o of b.options)o.disabled=o.value===a.value;
const pair=[profiles.get(a.value),profiles.get(b.value)];root.querySelector('[data-swap-home]').append(swap);out.replaceChildren();
const heroes=node('div',null,'vh-matchup');
pair.forEach((p,index)=>{
const c=node('article',null,'vh-shoe');
if(url(p.image)){const img=node('img');img.src=url(p.image);img.alt=p.title;c.append(img)}
c.append(node('h2',p.title));
const verdict=content(p,'quick_verdict');verdict.classList.add('vh-shoe__intro');c.append(verdict);
const links=node('div',null,'vh-shoe__links');links.append(link(t.review,p.url));if(p.product)links.append(link(t.product,p.product,true));c.append(links);
heroes.append(c);
if(index===0){const center=node('div',null,'vh-versus');center.append(node('span','VS','vh-versus__badge'),swap);heroes.append(center)}
});out.append(heroes);
const scores=node('section',null,'vh-card');scores.append(node('h2',t.score),node('small',t.method));pair.forEach(p=>{const r=node('div',null,'vh-bar');r.append(node('span',p.title));const v=Number(p.score);if(p.score!=null&&p.score!==''&&Number.isFinite(v)&&v>=0&&v<=10){const m=node('meter');m.min=0;m.max=10;m.value=v;m.setAttribute('aria-label',p.title+' '+t.score);r.append(m,node('strong',v+'/10'))}else r.append(node('span',t.missing));scores.append(r)});out.append(scores);
const keys=[...new Set(pair.flatMap(p=>Object.keys(p.specs)))];if(keys.length){const sec=node('section');sec.append(node('h2',t.specs),node('p',t.spec_note));const table=node('table'),head=node('thead'),hr=node('tr');['',...pair.map(p=>p.title)].forEach(v=>{const th=node('th',v);th.scope='col';hr.append(th)});head.append(hr);table.append(head);const body=node('tbody');keys.forEach(k=>{const r=node('tr'),th=node('th',k);th.scope='row';r.append(th);pair.forEach(p=>r.append(node('td',p.specs[k]||t.missing)));body.append(r)});table.append(body);sec.append(table);out.append(sec)}
for(const key of ['strengths','weaknesses','best_for','not_suitable_for','quick_verdict']){const sec=node('section'),fold=['best_for','not_suitable_for'].includes(key);if(!fold)sec.append(node('h2',t[key]));const grid=node('div',null,'vh-pair vh-detail');pair.forEach(p=>{if(fold){const c=node('details',null,'vh-accordion '+(key==='best_for'?'vh-accordion--choose':'vh-accordion--skip')),summary=node('summary',null,'vh-accordion__summary');summary.append(node('span',key==='best_for'?'✓':'−','vh-accordion__icon'),node('span',(key==='best_for'?'Who should choose ':'Who should skip ')+p.title+'?'),node('span',null,'vh-accordion__chevron'));const body=content(p,key);body.classList.add('vh-accordion__body');c.append(summary,body);animateAccordion(c,summary);grid.append(c)}else{const c=node('article',null,'vh-card '+(key==='weaknesses'?'vh-weak':'vh-good'));c.append(node('h3',p.title),content(p,key));if(key==='quick_verdict')c.append(link(t.review,p.url));grid.append(c)}});sec.append(grid);out.append(sec)}
const u=new URL(location.href);u.searchParams.set('shoe1',a.value);u.searchParams.set('shoe2',b.value);history.replaceState(null,'',u);status.textContent=(failed?t.error+' ':'')+t.updated+': '+pair.map(p=>p.title).join(' / ');
}
a.addEventListener('change',render);b.addEventListener('change',render);const swap=root.querySelector('[data-swap]');swap.disabled=false;swap.addEventListener('click',()=>{const old=a.value;a.value=b.value;b.value=old;render()});const pickers=[makePicker(a,'a'),makePicker(b,'b')];
const compare=root.querySelector('[data-compare]');compare.disabled=false;compare.addEventListener('click',()=>{pickers.forEach(p=>p.close());render();out.setAttribute('tabindex','-1');out.focus({preventScroll:true});out.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'})});
const selectorSwap=swap.cloneNode(true);selectorSwap.removeAttribute('data-swap');selectorSwap.className='vh-select__swap';selectorSwap.setAttribute('aria-label',swap.textContent.trim());selectorSwap.textContent='⇄';selectorSwap.addEventListener('click',()=>swap.click());root.querySelector('.vh-select').append(selectorSwap);render();
});
}
initVerdosaH2H();document.addEventListener('shopify:section:load',initVerdosaH2H);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-home-comparisons"] && !Shopify.designMode) return;
  try {
    
function initVerdosaComparisonSwipe(){
document.querySelectorAll('.vd-home-comparisons').forEach(section=>{
if(section.dataset.swipeReady)return;
section.dataset.swipeReady='true';
const track=section.querySelector('.vd-home-comparisons__grid');
const cards=[...track.children];
const inset=()=>parseFloat(getComputedStyle(track).scrollPaddingLeft)||0;
const dots=[...section.querySelectorAll('.vd-comparison-dots button')];
const update=()=>{
let nearest=0, distance=Infinity;
cards.forEach((card,i)=>{const d=Math.abs(card.getBoundingClientRect().left-track.getBoundingClientRect().left-inset());if(d<distance){distance=d;nearest=i;}});
if(track.scrollLeft>=track.scrollWidth-track.clientWidth-2)nearest=cards.length-1;
dots.forEach((dot,i)=>{if(i===nearest)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
};
dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:track.scrollLeft+cards[i].getBoundingClientRect().left-track.getBoundingClientRect().left-inset(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
track.addEventListener('scroll',update,{passive:true});
});
}
initVerdosaComparisonSwipe();
document.addEventListener('shopify:section:load',initVerdosaComparisonSwipe);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-latest-reviews"] && !Shopify.designMode) return;
  try {
    
function initVerdosaReviewCarousels(){
document.querySelectorAll('.vd-latest-reviews').forEach(section=>{
if(section.dataset.carouselReady)return;
section.dataset.carouselReady='true';
const track=section.querySelector('.vd-latest-reviews__grid');
const cards=[...track.children];
const dots=[...section.querySelectorAll('.vd-review-dots button')];
function position(card){return track.scrollLeft+card.getBoundingClientRect().left-track.getBoundingClientRect().left-22}
function update(){
if(!matchMedia('(max-width:749px)').matches)return;
let active=0;
if(track.scrollLeft>0 && track.scrollLeft>=track.scrollWidth-track.clientWidth-2)active=cards.length-1;
else cards.forEach((card,i)=>{if(Math.abs(position(card)-track.scrollLeft)<Math.abs(position(cards[active])-track.scrollLeft))active=i});
dots.forEach((dot,i)=>{if(i===active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
}
dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:position(cards[i]),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));
track.addEventListener('scroll',update,{passive:true});
new ResizeObserver(update).observe(track);
update();
});
}
initVerdosaReviewCarousels();
document.addEventListener('shopify:section:load',initVerdosaReviewCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-popular-gear"] && !Shopify.designMode) return;
  try {
    
function initVerdosaGear(){
document.querySelectorAll('.vd-popular-gear').forEach(section=>{
if(section.dataset.carouselReady)return;
section.dataset.carouselReady='true';
const track=section.querySelector('.vd-popular-gear__grid');
const cards=[...track.children];
const dots=[...section.querySelectorAll('.vd-gear-dots button')];
function target(i){return Math.min(track.scrollWidth-track.clientWidth,track.scrollLeft+cards[i].getBoundingClientRect().left-track.getBoundingClientRect().left-22)}
function update(){
if(!matchMedia('(max-width:749px)').matches)return;
let active=0;
dots.forEach((dot,i)=>{if(Math.abs(target(i)-track.scrollLeft)<Math.abs(target(active)-track.scrollLeft))active=i});
dots.forEach((dot,i)=>{if(i===active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
}
dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:target(i),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));
let pending=false;
track.addEventListener('scroll',()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{update();pending=false})},{passive:true});
new ResizeObserver(update).observe(track);
update();
});
}
initVerdosaGear();
document.addEventListener('shopify:section:load',initVerdosaGear);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const imageButton = event.target.closest('[data-verdosa-image-direction]');
    if (imageButton) {
      const card = imageButton.closest('[data-verdosa-card]');
      const images = [...card.querySelectorAll('.verdosa-similar-card__image')];
      let index = Number(card.dataset.activeImage || 0);
      index += imageButton.dataset.verdosaImageDirection === 'next' ? 1 : -1;
      index = (index + images.length) % images.length;
      card.dataset.activeImage = index;
      images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
      card.querySelectorAll('[data-verdosa-dot]').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      card.querySelector('.verdosa-similar-card__more')?.classList.toggle('is-active', index > 2);
      return;
    }

    const railButton = event.target.closest('[data-verdosa-rail]');
    if (railButton) {
      const track = railButton.closest('.verdosa-similar__carousel').querySelector('[data-verdosa-track]');
      const card = track.querySelector('[data-verdosa-card]');
      const distance = card.getBoundingClientRect().width + 24;
      track.scrollBy({ left: railButton.dataset.verdosaRail === 'next' ? distance : -distance, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-reviews-hub"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-review-search]').forEach(search => {
    if (search.dataset.ready) return;
    search.dataset.ready = 'true';
    const root = search.closest('.vrh'), input = search.querySelector('input'), list = root.querySelector('.vrh__featured'), status = search.querySelector('[role="status"]'), pagination = root.querySelector('.vrh__pagination'), controls = root.querySelector('.vrh-search-pages');
    const original = [...list.children].map(el => el.cloneNode(true));
    let all = original.filter(el => el.matches('.vrh-card')), loaded = !pagination, pending, page = 0, timer;
    const normalize = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const draw = () => {
      const query = normalize(input.value.trim()), terms = query.split(/\s+/).filter(Boolean);
      if (!query) {list.replaceChildren(...original.map(el => el.cloneNode(true))); if (pagination) pagination.hidden = false; controls.hidden = true; status.textContent = ''; return;}
      const matches = all.filter(el => terms.every(term => normalize(el.querySelector('h2').textContent).includes(term)));
      const pages = Math.ceil(matches.length / 9); page = Math.max(0, Math.min(page, pages - 1));
      const cards = matches.slice(page * 9, page * 9 + 9).map((el, i) => {const copy = el.cloneNode(true); copy.classList.toggle('vrh-card--featured', i === 0); return copy;});
      list.replaceChildren(...cards); if (pagination) pagination.hidden = true;
      status.textContent = !loaded ? status.dataset.loading : matches.length ? status.dataset.count.replace('[count]', matches.length) : status.dataset.empty;
      controls.hidden = pages < 2; controls.querySelector('span').textContent = (page + 1) + ' / ' + pages;
      controls.querySelector('[data-direction="-1"]').disabled = page === 0; controls.querySelector('[data-direction="1"]').disabled = page >= pages - 1;
    };
    const load = async () => {
      if (loaded) return;
      if (pending) return pending;
      pending = (async () => {
        let url = new URL(search.dataset.blogUrl, location.origin); const seen = new Set(), collected = [];
        while (url && !seen.has(url.href)) {
          seen.add(url.href); const response = await fetch(url.href); if (!response.ok) throw new Error('Search load failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!doc.querySelector('.vrh__featured')) throw new Error('Missing reviews');
          collected.push(...doc.querySelectorAll('.vrh__featured .vrh-card'));
          const next = doc.querySelector('.vrh__pagination .next a'); url = next ? new URL(next.getAttribute('href'), location.origin) : null;
        }
        all = collected; loaded = true;
      })();
      try {await pending; draw();} catch (error) {draw(); if (input.value.trim()) status.textContent = status.dataset.error;} finally {pending = null;}
    };
    input.addEventListener('input', () => {clearTimeout(timer); page = 0; timer = setTimeout(() => {draw(); if (input.value.trim()) load();}, 120);});
    controls.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {page += Number(button.dataset.direction); draw();}));
  });
  init(); document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
